
const EVENTS = {
    // a copy from backend/api/models/EventModel.ts
    TYPE_ID: {
        Done: 1,
        Prio: 2,
        Unprio: 3,
        Task: 4,
        Discuss: 5,
        Upload: 6,
        Delay: 7,
        //DelayTill: 8,
        Mention: 9,
        Topic: 10,
        Undelay: 11,
        Repeat: 12,
        Deadline: 13,
        Comment: 14,
        Assign: 15,
        Templated: 16,
        Thread: 17,
        TopicRename: 18,
        ThreadSetOpen: 19,
        ChatRename: 20,
        TaskDue: 21,
        TaskOverdue: 22,
        Undone: 23,
        Undeadline: 24,
        Delete: 25,
        TopicDelete: 26,
        TopicClose: 27,
        TopicReopened: 28,
        Undelete: 29,
        Pick: 30,
        PickUpdate: 31,
        PickDelete: 32,
        Unassign: 33,
        TopicDeletePending: 34,
        Defer: 35,
        Undefer: 36,
        TopicDeletePendingDueClose: 37,
        TariffChanged: 38,
        AccessRequest: 39,
        StageDone: 40,
        StageUndone: 41,
        AuthEmail: 42,
        Rename: 43,
        Report: 49,
    }
};

export default EVENTS;